export default __webpack_public_path__ + "static/Prometheus_Pipeline-60be81f1e6633017f92dce2bbe7cbd51.png";